import { render, staticRenderFns } from "./selfhandle-setting.vue?vue&type=template&id=ad416a5c&scoped=true"
import script from "./selfhandle-setting.vue?vue&type=script&lang=js"
export * from "./selfhandle-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad416a5c",
  null
  
)

export default component.exports